module.exports = __webpack_public_path__ + "travelstaytion.png?1e27ad4faf468e87d174dcfd029f5955";